import Empty from "../../images/components/empty.svg"
import Foxi from "../../images/templates/foxi.jpg"
import FoxiPro from "../../images/templates/foxi-pro.jpg"
import Milo from "../../images/templates/milo.jpg"
import Toki from "../../images/templates/toki.jpg"
import Mizu from "../../images/templates/mizu.jpg"
import MizuLight from "../../images/templates/mizu-light.jpg"
import Kiro from "../../images/templates/kiro.jpg"

export const templateItems = [
  {
    theme: "Kiro",
    themePreviewLink: "https://kiro-theme.netlify.app/",
    themeBuyLink:
      "https://oxygenna.lemonsqueezy.com/checkout/buy/556eb780-474a-4bdc-abe1-9add72fbd65a",
    themeDescription:
      "Kiro is an AI product landing page theme built for teams launching AI products, virtual agents, and intelligent assistant platforms.",
    themeImage: Kiro,
    themePrice: "$79.99",
    categories: ["Astro v6", "TailwindCSS v4"],
    featured: true,
    new: true,
  },
  {
    theme: "Mizu Light",
    themePreviewLink: "https://mizu-light-theme.netlify.app/",
    themeBuyLink: "https://github.com/oxygenna-themes/mizu-light-astro-theme",
    themeDescription:
      "Mizu Light is a product launch template designed specifically for modern SaaS products, digital launches, and ambitious startups.",
    themeImage: MizuLight,
    themePrice: "Free",
    categories: ["Astro v6", "TailwindCSS v4"],
    new: true,
    featured: true,
  },
  {
    theme: "Mizu",
    themePreviewLink: "https://mizu-theme.netlify.app/",
    themeBuyLink:
      "https://oxygenna.lemonsqueezy.com/buy/fd0e3620-9459-46a5-9883-0fab3282ab01",
    themeDescription:
      "Mizu is a product launch template, with 12 pre-built pages designed for modern SaaS products, digital launches, and startups.",
    themeImage: Mizu,
    themePrice: "$79.99",
    categories: ["Astro v6", "TailwindCSS v4"],
    featured: true,
  },
  {
    theme: "Toki",
    themePreviewLink: "https://toki-theme.netlify.app/",
    themeBuyLink:
      "https://oxygenna.lemonsqueezy.com/buy/b0e78998-035e-4fc2-bc70-ae3993ae7235",
    themeDescription:
      "A standout agency template with striking design, blazing speed, built for modern agencies and creatives.",
    themeImage: Toki,
    themePrice: "$79.99",
    categories: ["Astro v6", "TailwindCSS v4"],
    featured: true,
  },
  {
    theme: "Milo",
    themePreviewLink: "https://milo-theme.netlify.app/",
    themeBuyLink:
      "https://oxygenna.lemonsqueezy.com/buy/847d975c-3c30-45fb-a3fa-fd2ce72fa22e",
    themeDescription:
      "A clean and modern resume template for Astro, built with Tailwind CSS, perfect for showcasing your professional profile online.",
    themeImage: Milo,
    themePrice: "$39.99",
    categories: ["Astro v6", "TailwindCSS"],
    featured: true,
  },
  {
    theme: "Foxi Pro",
    themePreviewLink: "https://foxi-pro.netlify.app/",
    themeBuyLink:
      "https://oxygenna.lemonsqueezy.com/buy/2e32ec07-aa31-45a4-835d-8ebb7f6048cc",
    themeDescription:
      "A premium Tailwind CSS template with perfect PageSpeed, SEO optimization, light/dark modes, responsive design, and pre-built pages for fast, customizable development.",
    themeImage: FoxiPro,
    themePrice: "$79.99",
    featured: true,
    categories: ["Astro v6", "TailwindCSS"],
  },
  {
    theme: "Foxi",
    themePreviewLink: "https://foxi.netlify.app/",
    themeBuyLink: "https://github.com/oxygenna-themes/foxi-astro-theme",
    themeDescription:
      "Free Template with superb performance and amazing design, perfect for startups and SaaS websites, built with Astro & Tailwind CSS.",
    themeImage: Foxi,
    themePrice: "Free",
    categories: ["Astro v6", "TailwindCSS"],
  },
]
